import { render, staticRenderFns } from "./magazines.vue?vue&type=template&id=a49f2728&scoped=true"
import script from "./magazines.vue?vue&type=script&lang=js"
export * from "./magazines.vue?vue&type=script&lang=js"
import style0 from "./magazines.vue?vue&type=style&index=0&id=a49f2728&prod&scoped=true&lang=css"
import style1 from "./magazines.vue?vue&type=style&index=1&id=a49f2728&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49f2728",
  null
  
)

export default component.exports